/* eslint-disable react/jsx-filename-extension */
import React, { useEffect, useReducer, useRef } from 'react';

import Tooltip from '../../../views/components/Tooltip/index.js';
import styles from './styles.module.scss';

export default function useTooltips({ offsets: outerOffsets }) {
  const nodeRef = useRef();
  const [offsets, updateOffsets] = useReducer(
    () => ({
      left: nodeRef.current.offsetLeft + outerOffsets.left,
      top: nodeRef.current.offsetTop + outerOffsets.top
    }),
    { left: 0, top: 0 }
  );
  // Set offsets on mount & resize
  useEffect(() => {
    updateOffsets();

    if (globalThis.addEventListener) {
      globalThis.addEventListener('resize', updateOffsets);
    } else if (globalThis.attachEvent) {
      globalThis.attachEvent('onresize', updateOffsets);
    }

    return () => {
      if (globalThis.addEventListener) {
        globalThis.removeEventListener('resize', updateOffsets);
      } else if (globalThis.attachEvent) {
        globalThis.detachEvent('onresize', updateOffsets);
      }
    };
  }, []);

  const [tooltips, updateTooltip] = useReducer(
    (state, { id, html, position, shouldRemove = false }) => {
      const nextState = state.filter(t => t.id !== id);

      if (!id) {
        // TODO temporary warning for non compliant tooltips

        console.warn('Tooltip id is not defined');
        return nextState;
      }

      if (shouldRemove) {
        return nextState;
      }

      return [...nextState, { id, html, position }];
    },
    []
  );
  return {
    nodeRef,
    updateTooltip,
    tooltipsEl: (
      <div className={styles['surpas-tooltips']}>
        {tooltips.map(tooltip => (
          <Tooltip key={tooltip.id} offsets={offsets} {...tooltip} />
        ))}
      </div>
    )
  };
}
